import { apiSlice } from 'store/slices/api/api-slice';
import {
    ImageSuccessResponse,
    SphereImagesRequest,
} from 'types/card/card-sphere';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        sphereImageUpdate: builder.mutation<
            ImageSuccessResponse,
            SphereImagesRequest
        >({
            query: (sphereImagesRequest: SphereImagesRequest) => ({
                url:
                    `/sphere/add-sphere-image/` +
                    sphereImagesRequest.cardSphereId,
                method: 'POST',
                body: sphereImagesRequest.image,
                header: {},
            }),
        }),

        sphereBackgroundImageUpdate: builder.mutation<
            ImageSuccessResponse,
            SphereImagesRequest
        >({
            query: (sphereImagesRequest: SphereImagesRequest) => ({
                url:
                    `/sphere/add-sphere-background-image/` +
                    sphereImagesRequest.cardSphereId,
                method: 'POST',
                body: sphereImagesRequest.image,
                header: {},
            }),
        }),

        sphereImageDelete: builder.mutation({
            query: (id: string) => ({
                url: `/sphere/sphere/` + id,
                method: 'DELETE',
                header: {},
            }),
        }),
    }),
});

export const {
    useSphereImageUpdateMutation,
    useSphereBackgroundImageUpdateMutation,
    useSphereImageDeleteMutation,
} = importTradeDataApiSlice;
